// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ik-0";